define(
    'postLogin/logout',[
        'lodash', 'plugins/router', 'atn/atn', 'dataSource/site',
        'dataSource/logout', '../viewmodels/app/components/__reportScheduleForm'
    ],
    function(_, router, atn, site, logout, reportScheduleForm) {
        'use strict';

        //TODO: use constants
        var pages = {
            logoutError: '#site/failure/serverUnreachable',
            logout: '#site/logout'
        };

        return {
            allServicesLogout: allServicesLogout,
            thisServiceLogout: thisServiceLogout
        };

        function allServicesLogout() {
            //When create/update a report the schedule object was dirty and while trying to cloud logout from same screen 
            //browser will give redirect warnning to avoid this schedule object needs to reset.
            reportScheduleForm.resetScheduleObject();
            
            var deferred = $.Deferred();
            var promise = logout.logout();
            promise.done(function(response) {
                atn.isLoggedOut(true);
                atn.dataCache.removeLocalStorageVariable('ticketKey');
                window.location.replace(response.redirectUrl);
                deferred.resolve(response);
            });

            promise.fail(function(xhr) {
                if(xhr.status === 403){
                    _.defer(router.navigate, pages.logout);
                } else {
                    _.defer(router.navigate, pages.logoutError);
                }
                deferred.reject(xhr);
            });

            return deferred.promise();
        }

        function thisServiceLogout() {

            var deferred = $.Deferred();
            var promise = logout.logout();
            promise.done(function(response) {
                atn.isLoggedOut(true);
                _.defer(router.navigate, pages.logout);
                deferred.resolve(response);
            });

            promise.fail(function(xhr) {
                if(xhr.status === 403){
                    _.defer(router.navigate, pages.logout);
                } else {
                    _.defer(router.navigate, pages.logoutError);
                }
                deferred.reject(xhr);


            });
            return deferred.promise();
        }
    }
);
